import { useState, useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { links } from "./config";

const useNavLinks = () => {
  const router = useRouter();
  const path = usePathname();
  const [active, setActive] = useState("");

  useEffect(() => {
    const activeLink = links.find((link) => link.link === path)?.label;

    if (activeLink) {
      setActive(activeLink);
    } else {
      setActive("");
    }
  }, [path]);

  const handleLinkClick = (label: string, link: string) => {
    setActive(label);
    router.push(link);
  };

  return { active, handleLinkClick };
};

export default useNavLinks;